import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Grid, TextField, Typography } from '@material-ui/core';
import classNames from 'classnames';
import moment from 'moment';

import { ApiToken, useDeleteApiTokenMutation } from 'api';
import { useNotify } from 'hooks';
import { Alert } from 'components';
import { useDeleteApiToken } from 'updaters';

import useStyles from './styles';

interface Props {
  token: ApiToken;
}

const ExistingKey: FC<Props> = ({ token }) => {
  const classes = useStyles();
  const notify = useNotify();
  const { t } = useTranslation();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const mutationOptions = useDeleteApiToken();

  const { mutate: deleteMutation } = useDeleteApiTokenMutation({
    onSuccess: () => notify.info({ message: t('components:apiKeyRevoked') }),
    ...mutationOptions,
  });

  function toggleConfirm() {
    setConfirmOpen(!confirmOpen);
  }

  return (
    <Fragment>
      <Alert
        open={confirmOpen}
        onConfirm={() => {
          toggleConfirm();
          deleteMutation({ data: { token_id: token.token_id } });
        }}
        onCancel={toggleConfirm}
        message={t('components:apiKeyRevoke')}
        confirm={t('common:revoke')}
      />
      <Grid container justify="space-between" alignItems="center" spacing={2}>
        <Grid item xs>
          <TextField disabled fullWidth label={t('components:keyName')} value={token.token_name} />
          <Box marginTop={0.5}>
            <Typography variant="body1" color="textSecondary">
              {t('components:KeyNameAdded', {
                date: moment.unix(token.created_at).format('ll'),
              })}
            </Typography>
          </Box>
        </Grid>
        <Grid item>
          <Button
            onClick={() => setConfirmOpen(true)}
            fullWidth
            className={classNames(classes.button, classes.revokeButton)}
            size="large"
            variant="outlined"
          >
            {t('common:revoke')}
          </Button>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default ExistingKey;
